<template>
    <div>
        <component v-if="!isWishlistContentPage" :is="WishlistList" :showWishlistContentPage="showWishlistContentPage"/>
        <component v-else :is="WishlistContent" :showWishlistContentPage="showWishlistContentPage"/>
    </div>
</template>
  
<script setup>
import { onMounted, ref, computed, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import WishlistList from './components/wishlist-page/wishlist-list/index.vue';
import WishlistContent from './components/wishlist-page/wishlist-content/index.vue';

const store = useStore();

const isWishlistContentPage = ref(false);

const wishlistContentDetailsList = computed(() => store.state.wishlistContentDetailsList);

const showWishlistContentPage = (value, lid) => {
  isWishlistContentPage.value = value;

  const params = new URLSearchParams(window.location.search);

  if (value) {
    params.set('lid', lid);
  } else {
    params.delete('lid');
  }

  window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
};

onMounted(() => {
  init();
  // Listen for popstate events (browser back/forward button)
  window.addEventListener('popstate', init);
});

const init = async () => {
  await store.dispatch('fetchWishlistItems');

  const params = new URLSearchParams(window.location.search);

  if (params.has('lid')) {
    const listDetails = getWishlistDetails(params.get('lid'));
    if (listDetails) {
      store.dispatch('setSelectedWishlistDetails', listDetails);
      isWishlistContentPage.value = true;
    }
  } else {
    isWishlistContentPage.value = false;
  }
};

const getWishlistDetails = (lid) => {
  return wishlistContentDetailsList.value.find((item) => item.lid == lid);
};

onUnmounted(() => {
  window.removeEventListener('popstate', init);
});
</script>
